import { afterEveryRender, Component, Inject, inject, output } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {RdsButtonModule, RdsIconComponent, RdsSliderModule} from "@rds/angular-components";
import {DOCUMENT} from "@angular/common";

type TempZoomForm = FormGroup<{
  zoom: FormControl<number>;
}>

@Component({
  selector: 'app-zoom-control',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RdsIconComponent,
    RdsSliderModule,
    RdsButtonModule
  ],
  templateUrl: './zoom-control.component.html',
  styleUrl: './zoom-control.component.scss'
})
export class ZoomControlComponent {
  zoomChange = output<number>()
  formBuilder = inject(FormBuilder)
  form: TempZoomForm = this.formBuilder.nonNullable.group({
    zoom: [80, [Validators.required, Validators.max(100), Validators.min(30)]],
  })
  readonly zoomStep = 5
  constructor(@Inject(DOCUMENT) private document: Document) {
    this.form.valueChanges.subscribe(() => {
      this.onFormSubmit()
    })

    afterEveryRender({ write: () => {
        const sliderWrapper = this.document.querySelector(".rds-slider-horizontal .rds-slider-wrapper") as HTMLDivElement;
        sliderWrapper?.style.setProperty("top", "unset");
    } }, )
  }

// View + Control(Model) = app
// View = Control(Model) = app

  zoom(factor: number){
    this.form.controls.zoom.setValue(this.form.controls.zoom.value + factor)
  }

  onFormSubmit(){
    if(this.form.valid){
      this.zoomChange.emit(this.form.controls.zoom.value/100)
    }
  }
}
